import './index.css'
import {
  getFontFamily,
  getFontSize,
  getSectionPaddings,
} from '@disco/content-editor/editor-utils'
import { isDark } from '@disco/utils/color-utils'
import cn from 'clsx'
import * as React from 'react'
import type { Campaign, CampaignData } from 'types/content-editor'
import type { User } from 'types/user'
import SectionDragWrapper from 'containers/dnd/campaign-editor/section-drag-wrapper'
import Column from './column'
import EmailElement from './email-element'
import InsertPoint from './insert-point'
import Section from './section'
type Props = {
  campaignId?: string
  campaign: Campaign | null | undefined
  onDuplicateSection?: (index: number) => any
  onDeleteSection?: (index: number) => any
  onEditSection?: (index: number) => any
  readOnly?: boolean
  campaignData?: CampaignData
  className: string
  user: User
}
export default class ContentEditor extends React.Component<
  Props,
  {
    debugMarkup: string
  }
> {
  render(): null | React.ReactNode {
    const { campaign, campaignId, readOnly, campaignData, className, user } =
      this.props
    if (!campaign || !campaign.sections) return null
    const { sections } = campaign
    const sectionsBlock = sections.map((section, sectionIndex: number) => {
      const { h, v } = getSectionPaddings(section, campaign)
      const sectionContent = section.columns.map((column, columnIndex) => {
        return (
          <Column
            key={`column-${columnIndex}`}
            style={{
              padding: `${v}px ${h}px`,
            }}
          >
            {column.columnContent
              ? column.columnContent.map((content, contentIndex) => (
                  <div key={`element-${contentIndex}`}>
                    <EmailElement
                      component={content}
                      editMode={!readOnly && section.editMode}
                      section={section}
                      sectionIndex={sectionIndex}
                      columnIndex={columnIndex}
                      contentIndex={contentIndex}
                      campaignData={campaignData}
                      campaign={campaign}
                    />
                  </div>
                ))
              : null}
          </Column>
        )
      })
      const sectionStyle = {
        fontSize: `${getFontSize(section, campaign)}px`,
        fontFamily: getFontFamily(section, campaign),
      }
      return (
        <div key={`block-${sectionIndex}`} style={sectionStyle}>
          {sectionIndex === 0 && !readOnly && campaignId ? (
            <InsertPoint
              campaignId={campaignId}
              type="section"
              sectionIndex={sectionIndex}
              wrapperClassName={cn({
                'content-editor__insert-point--empty-first-item':
                  sectionIndex === 0,
              })}
            />
          ) : null}
          <SectionDragWrapper sectionIndex={sectionIndex}>
            <Section
              backgroundColor={section.backgroundColor}
              color={section.color}
              readOnly={readOnly}
              disableEditing={section.disableEditing || readOnly}
              disableCopy={section.disableCopy}
              disableDelete={section.disableDelete && !user.is_support_user}
              index={sectionIndex}
              editMode={section.editMode} // editModeContents={editModeContents}
              onEdit={this.props.onEditSection}
              onDuplicate={this.props.onDuplicateSection}
              onDelete={this.props.onDeleteSection}
              draggable={sectionIndex < sections.length - 1}
            >
              {sectionContent}
            </Section>
          </SectionDragWrapper>
          {!readOnly && campaignId && sectionIndex < sections.length - 1 ? (
            <InsertPoint
              campaignId={campaignId}
              type="section"
              sectionIndex={sectionIndex + 1}
            />
          ) : null}
        </div>
      )
    })
    const style = {
      fontSize: `${getFontSize(null, campaign)}px`,
      fontFamily: getFontFamily(null, campaign),
    }
    const viewOnlineColor = isDark(campaign.generalBackground || '#fff')
      ? '#eee'
      : '#222'
    return (
      <React.Fragment>
        <div
          hidden
          className="email-content__web-link"
          style={
            readOnly
              ? {
                  color: viewOnlineColor,
                }
              : null
          }
        >
          View this email in your browser
        </div>
        <div className={className} style={style}>
          {sectionsBlock}
        </div>
      </React.Fragment>
    )
  }
}
